import { useState, useCallback } from 'react';
import useFetch from './useFetch';

export function usePageStatistics(contentId, contentType) {
  const summaryUrl = `/admin/dashboard/statistics_summary/${contentType}/${contentId}`;
  const {
    data: summary,
    loading: isSummaryLoading,
    error: summaryError,
    refresh: refreshSummary,
  } = useFetch(summaryUrl);

  const [details, setDetails] = useState({});
  const [loadingDetailsType, setLoadingDetailsType] = useState(null);
  const [detailsError, setDetailsError] = useState(null);

  const loadDetailsForType = useCallback(
    async (type) => {
      if (details[type]) {
        setDetails((prev) => {
          const newDetails = { ...prev };
          delete newDetails[type];
          return newDetails;
        });
        return;
      }
      setLoadingDetailsType(type);
      setDetailsError(null);
      try {
        const response = await fetch(
          `/admin/dashboard/statistics_details/${contentType}/${contentId}?type=${type}&only_without_backlinks=true`
        );
        if (!response.ok) {
          setDetailsError(`Details for ${type} could not be loaded.`);
          return;
        }
        const data = await response.json();
        setDetails((prev) => ({ ...prev, [type]: data.objects }));
      } catch (err) {
        setDetailsError(`Details for ${type} could not be loaded.`);
      } finally {
        setLoadingDetailsType(null);
      }
    },
    [contentId, contentType, details]
  );

  return {
    summary,
    details,
    isSummaryLoading,
    summaryError,
    loadingDetailsType,
    detailsError,
    loadDetailsForType,
    refreshSummary,
  };
}
